package com.hyperether.goodjob.scenes.jobs

import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.navigation.NavHostController
import com.hyperether.goodjob.models.CompletionReportStatus
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.repository.remote.model.CompletionReportResponse
import com.hyperether.goodjob.util.Constants.COMPLETED_STATUS

@Composable
fun CompletionReportOverview(
    viewModel: JobDetailsViewModel,
    navHostController: NavHostController,
    job: Job,
    report: CompletionReportResponse?,
    onOpenPdfClick: (String) -> Unit
) {
    LaunchedEffect(Unit) {
        viewModel.downloadCompletionReportFiles(report)
    }

    Column {
        CompletionReportOverviewView(
            viewModel = viewModel,
            completionReportResponse = report,
            isEmployee = viewModel.isEmployee(),
            jobFinished = job.status == COMPLETED_STATUS,
            onApproveClick = {
                job.id?.let {
                    viewModel.finishJob(it, CompletionReportStatus.completed.name.lowercase())
                }
            },
            onRejectClick = {
                job.id?.let {
                    viewModel.finishJob(it, CompletionReportStatus.rejected.name.lowercase())
                }
            },
            onOpenPdfClick = onOpenPdfClick
        )
//        if (viewModel.showNoteAdded.value) {
//            PopUpDialog(
//                onDismiss = {
//                    viewModel.showNoteAdded.value = false
//                    navHostController.popBackStack()
//                },
//                title = stringResource(Res.string.success).uppercase(),
//                message = stringResource(Res.string.job_finished),
//                onPositiveBtnClicked = {
//                    viewModel.showNoteAdded.value = false
//                    navHostController.popBackStack()
//                },
//                positiveBtnText = stringResource(Res.string.ok)
//            )
//        }
//        if (viewModel.showPopUpError.value) {
//            ErrorDialog(
//                onDismiss = { viewModel.showPopUpError.value = false },
//                title = stringResource(Res.string.error),
//                message = viewModel.errorText.value
//            )
//        }
//        if (viewModel.showLoader.value) {
//            FullScreenProgressBar()
//        }
    }
}